import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Search from '../Search/Search';
import { SortableContainer, SortableElement, arrayMove } from 'react-sortable-hoc';
import Structure from '../Common/Structure';
import LocalizedStrings from '../Localization/localization';
import NotificationAttachment from './NotificationAttachment';
import { isSmartphone } from '../../helpers';
import './ContentPicker.css';

const SortableItem = SortableElement(NotificationAttachment);
const SortableList = SortableContainer(({ resources, onDelete }) => (
    <div className="pdc-col-wizard-step-resource-list">
        {resources.map((resource, index) => (
            <SortableItem
                key={resource.resourceId}
                index={index}
                resource={resource}
                onDelete={onDelete}
                disabled={onDelete ? false : true}
            />
        ))}
    </div>
));

class ContentPicker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            tab: 0,
            smartphoneView: undefined,
        };
    }

    componentDidMount() {
        isSmartphone((match) => this.handleSizeChange(match));
    }

    handleSizeChange = (match) => {
        this.setState({ smartphoneView: match });
    };

    onEditingChange = (newEditing) => {
        this.setState({ editing: newEditing });
    };

    setTab = (tab) => {
        this.setState({ tab });
    };

    handleSearchResultsSelected = (resource) => {
        let newRes = Object.assign([], this.props.contents);
        let found = newRes.find((res) => {
            return res.resourceId === resource.resourceId;
        });
        if (!found) {
            let resourceObj = {
                resourceId: resource.resourceId,
                resourceType: resource.resourceType,
                resourceSubtype: resource.resourceSubtype,
                resourceImage: resource.image,
            };

            if (resource.names !== undefined) {
                resourceObj.names = resource.names;
            } else {
                resourceObj.names = resource.title;
            }

            newRes.push(resourceObj);
            this.props.onDataChange(newRes);
        }
    };

    onSortEnd = ({ oldIndex, newIndex }) => {
        let newRes = Object.assign([], this.props.contents);
        newRes = arrayMove(newRes, oldIndex, newIndex);
        this.props.onDataChange(newRes);
    };

    handleDelete = (deletedResource) => {
        let newRes = Object.assign([], this.props.contents);
        newRes = newRes.filter((resource) => {
            return resource.resourceId !== deletedResource.resourceId;
        });
        this.props.onDataChange(newRes);
    };

    handleStructureContentSelected = (content, pathArray) => {
        // this.setState({ auxSelected: content });
        let resource = {
            resourceId: content.contentId,
            resourceType: 'content',
            resourceSubtype: content.objectType,
            names: content.names,
            image: content.previewImage,
        };
        this.handleSearchResultsSelected(resource);
    };

    // handleAddFromStructure = () => {
    //     let content = this.state.auxSelected;
    //     console.log('auxSelected', content);
    //     let resource = {
    //         resourceId: content.contentId,
    //         resourceType: 'content',
    //         resourceSubtype: content.objectType,
    //         names: content.names
    //     };
    //     this.handleSearchResultsSelected(resource);
    // }

    render() {
        // let language = new AppContext().getLanguage();
        let containerStyle = {
            borderRadius: '2px',
            marginTop: '10px',
            marginBottom: '10px',
            color: '#000',
            padding: '10px',
        };

        if (this.state.smartphoneView === true) {
            containerStyle = {
                color: '#000',
                padding: '10px',
            };
        }

        return (
            <div style={containerStyle}>
                <div>
                    {this.props.disabled ? (
                        <div></div>
                    ) : (
                        [
                            <div key={'tabs-menu'}>
                                <div
                                    onClick={() => this.setTab(0)}
                                    className={
                                        this.state.tab === 0
                                            ? 'pdc-col-wizard-step-tab pdc-col-wizard-step-tab-selected'
                                            : 'pdc-col-wizard-step-tab'
                                    }
                                >
                                    {LocalizedStrings.search}
                                </div>
                                <div
                                    onClick={() => this.setTab(1)}
                                    className={
                                        this.state.tab === 1
                                            ? 'pdc-col-wizard-step-tab pdc-col-wizard-step-tab-selected'
                                            : 'pdc-col-wizard-step-tab'
                                    }
                                >
                                    {LocalizedStrings.structure}
                                </div>
                            </div>,
                            <div
                                key={'conent-chooser'}
                                className={
                                    this.state.smartphoneView === true
                                        ? 'pdc-col-wizard-step-content-container-smartphone'
                                        : 'pdc-col-wizard-step-content-container'
                                }
                            >
                                {this.state.tab === 0 ? (
                                    <div style={{ minHeight: '300px', marginTop: '10px', textAlign: 'center' }}>
                                        <Search
                                            notify={this.props.notify}
                                            editing={this.state.editing}
                                            onEditingChange={this.onEditingChange}
                                            searchStyle={{ field: { color: 'black', width: '90%' }, iconStyle: { color: 'black' } }}
                                            onResultSelected={this.handleSearchResultsSelected}
                                            exclusions={['col', 'mtg', 'form']}
                                            theme={'dark'}
                                            shareContext={this.props.shareContext}
                                            cols={2}
                                            embeded={true}
                                        />
                                    </div>
                                ) : (
                                    <div style={{ minHeight: '300px', marginTop: '10px' }}>
                                        <Structure isInside={true} onContentSelected={this.handleStructureContentSelected} />
                                    </div>
                                )}
                            </div>,
                        ]
                    )}
                    <div
                        className={
                            this.state.smartphoneView === true
                                ? 'pdc-col-wizard-step-resources-container-smartphone'
                                : 'pdc-col-wizard-step-resources-container'
                        }
                        style={this.props.disabled ? { border: 'none', width: '100%' } : {}}
                    >
                        {this.props.contents && this.props.contents.length > 0 ? (
                            <SortableList
                                resources={this.props.contents}
                                onSortEnd={this.onSortEnd}
                                onDelete={this.props.disabled ? undefined : this.handleDelete}
                                useDragHandle={false}
                                distance={2}
                            />
                        ) : (
                            ''
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
ContentPicker.propTypes = {
    contents: PropTypes.array.isRequired,
    onDataChange: PropTypes.func.isRequired,
    notify: PropTypes.func,
    disabled: PropTypes.bool,
    shareContext: PropTypes.bool,
};
export default ContentPicker;
